import {computed} from "@preact/signals-react";
import {appConfig, spacing} from "./app";


export const showHeader = computed(() => !(appConfig.value?.header?.hidden ?? false))
export const headerHeight = computed(() => appConfig.value?.header?.height)
export const headerMobile = computed(() => appConfig.value?.menu?.width?.mobile || 0)
export const headerDesktop = computed(() => appConfig.value?.menu?.width?.desktop || 0)
export const headerMobileSpacing = computed(() => showHeader.value
	? headerMobile.value + spacing.value
	: spacing.value )
export const headerDesktopSpacing = computed(() => showHeader.value
	? headerDesktop.value + spacing.value
	: spacing.value )
export const showHeaderCircle = computed(() => appConfig.value?.header?.showCircle ?? true)
export const showHeaderChat = computed(() => appConfig.value?.header?.showChat ?? true)
export const showHeaderNotifications = computed(() => appConfig.value?.header?.showNotifications ?? true)
export const showHeaderLang = computed(() => appConfig.value?.header?.showLang ?? true)
export const showHeaderCopyright = computed ( () => appConfig.value?.showHeaderCopyright ?? true)